module.exports = __webpack_public_path__ + "static/media/02A.ec6ca33f.png";